import React, { useState } from "react";
import FacebookLogin from "react-facebook-login";
import styled from "styled-components";
import FacebookIcon from "@material-ui/icons/Facebook";

const StyledSocialNetwork = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  button {
    height: 60px;
    width: 310px;
    position: relative;
    padding-left: 60px;
    border-radius: 30px !important;
    svg {
      margin-left: 15px;
      width: 40px;
      height: 40px;
      position: absolute;
      top: 8px;
      left: 0;
    }
  }
`;

const StyledSocialKakao = styled.div`
  width: 20%;
  height: 60px;
  cursor: pointer;
  border: 1px solid #cccccc;
  border-radius: 20px;
  position: relative;
  margin: 15px;
  background: yellow;
  left: 570px;
  img {
    width: 50px;
    height: 50px;
    position: absolute;
    left: 15px;
    top: 5px;
  }
  span {
    font-size: 28px;
    position: absolute;
    left: 75px;
    top: 8px;
  }
`;

const StyledSocialNaver = styled.div`
  width: 16%;
  height: 60px;
  cursor: pointer;
  border: 1px solid #cccccc;
  position: relative;
  margin: 15px;
  background: #0ea90ee0;
  left: 780px;
  img {
    width: 50px;
    height: 50px;
    position: absolute;
    left: 15px;
    top: 5px;
  }
  span {
    font-size: 28px;
    position: absolute;
    left: 75px;
    top: 8px;
    color: white;
  }
`;

const imgKakao =
  "https://i.pinimg.com/originals/57/4b/c0/574bc02828e025ed4dc6218d5957eb1e.png";
const imgNaver =
  "data:image/png;base64,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";

function SocialNetworksLogin(props) {
  const [accessToken, setAccessToken] = useState("");

  const responseFacebook = (response) => {
    console.log("resp ->", response);
    setAccessToken(response.accessToken);
  };

  const componentClicked = (data) => {
    console.log("data", data);
  };

  const RenderButtonLogin = () => {
    switch (props.type) {
      case "loginFacebook":
        return (
          <StyledSocialNetwork>
            <div>{accessToken}</div>
            <FacebookLogin
              appId="645299362838669"
              fields="name,email,picture"
              callback={responseFacebook}
              onClick={componentClicked}
              icon={<FacebookIcon size="medium" />}
            />
          </StyledSocialNetwork>
        );
      case "loginKakao":
        return (
          <StyledSocialKakao {...props}>
            <img src={imgKakao} />
            <span>Login with Kakao</span>
          </StyledSocialKakao>
        );
      case "loginNaver":
        return (
          <StyledSocialNaver {...props}>
            <img src={imgNaver} />
            <span>Login with Naver</span>
          </StyledSocialNaver>
        );
      default:
        return <div></div>
    }
  };

  return RenderButtonLogin();
}

export default SocialNetworksLogin;
